import http from "@/utils/http.js"


//查询专家顾问详情
export function getProfessorDetail(data) {
	return http({
		url: "/api/web/teacher/" + data,
		method: "GET",
	})
}